import axios from "axios";
import { CMS_API_ENDPOINT } from "../constants/api-constants";
import { LinktreeSettings, MatchDaySource } from "../types/Settings";
import { toMediaUrl } from "../utils/cms-utils";

const MATCH_DAY_SOURCES: MatchDaySource[] = ["men", "women", "manual"];

function toMatchDaySource(matchDay: any): MatchDaySource {
    if (MATCH_DAY_SOURCES.includes(matchDay.source)) {
        return matchDay.source;
    }
    // older CMS versions also know "api" and "custom"
    return "men";
}

export async function fetchSettings(): Promise<LinktreeSettings> {
    try {
        const response = await axios.get(
            `${CMS_API_ENDPOINT}/globals/linktree-settings`
        );

        const {
            header = {},
            hero = {},
            matchDay = {},
            banner = {},
            popup = {},
        } = response.data;

        return {
            header: {
                logoUrl: toMediaUrl(header.logo),
                alt: header.logo?.alt ?? "",
            },
            hero: {
                text: hero.text ?? "",
                sponsorImageUrl: toMediaUrl(hero.sponsorImage),
                sponsorAlt: hero.sponsorImage?.alt ?? "",
            },
            matchDay: {
                show: Boolean(matchDay.show),
                colorScheme: matchDay.colorScheme === "light" ? "light" : "dark",
                source: toMatchDaySource(matchDay),
                opponentName: matchDay.opponentName ?? "",
                opponentLogoUrl: toMediaUrl(matchDay.opponentLogo),
                kickoff: matchDay.kickoff ?? "",
                isHome: matchDay.isHome ?? true,
            },
            banner: {
                imageUrl: toMediaUrl(banner.image),
                alt: banner.image?.alt ?? "Banner",
                url: banner.url ?? "",
                showTop: Boolean(banner.showTop),
                showBottom: Boolean(banner.showBottom),
            },
            popup: {
                show: Boolean(popup.show),
                imageId: popup.image?.id != null ? String(popup.image.id) : "",
                imageUrl: toMediaUrl(popup.image),
                alt: popup.image?.alt ?? "Popup",
                url: popup.url ?? "",
                delaySeconds: popup.delaySeconds ?? 10,
            },
        };
    } catch (error) {
        throw new Error(`Failed to fetch settings: ${error}`);
    }
}
